import React, { memo } from 'react';
import { AnchorRect } from '@/hooks/common/useAnchoredPosition';
import { AdminDateTimePickers } from '@/components/common/admin/shared/AdminDateTimePickers';

interface Props {
  DateTimePicker: any;
  datePickerState: any;
  onDateChange: (event: any, selectedDate?: Date) => void;
  onConfirm: (pickerType: 'publish') => void;
  onCancel: () => void;
  onModeChange: (mode: 'date' | 'time') => void;
  webAnchor: AnchorRect | null;
}

export const BulletinDateTimePickers: React.FC<Props> = memo(({ 
  DateTimePicker,
  datePickerState,
  onDateChange,
  onConfirm,
  onCancel,
  onModeChange,
  webAnchor,
}) => {
  return (
    <AdminDateTimePickers
      DateTimePicker={DateTimePicker}
      datePickerState={datePickerState}
      onDateChange={onDateChange}
      onConfirm={onConfirm as any}
      onCancel={onCancel}
      onModeChange={onModeChange}
      enabledPickers={{ publish: true }}
      titles={{ publish: 'Publish Time' }}
      webAnchor={webAnchor}
    />
  );
});

BulletinDateTimePickers.displayName = 'BulletinDateTimePickers';


